import styled from '@emotion/styled';

export * from '../sharedStyles';

export const LeftBlock = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const RightBlock = styled.div`
  display: flex;
`;
